<template>
  <!-- mv-colloquium -->
    <div class="mv-colloquium">

        <cqtextimagesection direction = "L" :imagesrc="images.manan" :showPlayBtn="true" showImgText="WATCH HOW" showTLRBorder="true">
          
          <h5> <b class="red"> COLLOQUIUM - 'THE GAIN LIVINAR' </b> </h5>
          <cq-paratext> Manan has distilled all his learning and experience into creating  the <b class="red"> ‘Colloquium’ </b> which is the world’s only live implementation system - A <b class="red"> ‘Livinar’ </b> that shows you how to accomplish goals by handholding you through <b class="red"> 4 live games</b>. </cq-paratext>
          <cq-paratext> Over <b class="red"> 90 days </b> of live practicals you will  increase your efficiency, reduce your stress, sharpen your  focus and gain an altogether superior level of competence to produce results that otherwise seem impossible. </cq-paratext>
          <cq-paratext> <b class="red"> The Colloquium </b> will help you gain a sense of purpose that will drive you to achieve your goals and feel complete and fulfilled in totality by showing you how to put all your knowledge and experience into practice. It is a Fool Proof System that empowers you to produce <b class="red"> TANGIBLE RESULTS IN A TIME BOUND </b> manner not just once but as a <b class="red"> HABIT </b>.  </cq-paratext>

        </cqtextimagesection>
    </div>
    <!-- End mv-colloquium -->
</template>

<script>
import CQPara from '../../components/ui/CQPara.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Images
import manan from '../../assets/image/common/manan.png'
import playbtn from '../../assets/image/common/playbtn.png'

export default {
    components: {
        'cq-paratext' : CQPara,
        'cqtextimagesection': CQTextImageSection
    },
    data() {
        return {
            images: { 
                manan,
                playbtn
            }
        }
  }
}
</script>

<style scoped>
  .red{
    color: var(--primary-color);
    font-size: 20px;
  }

.mv-colloquium >>> h5{
  font-family: 'Seravek-Medium'; 
  font-size: 20px;
  padding-bottom: 3%;
}

.mv-colloquium >>> .showhow{
  position: absolute;
  left: 300px !important;
  z-index: 999;
  bottom: 40px;
}

@media only screen and (max-width: 992px){
  .mv-colloquium >>> .red{
    font-size: 18px;
  }

  .mv-colloquium >>> h5{
    text-align: center;
  }

  .mv-colloquium >>> #manan-img{
    position: relative;
    top: 0;
    left: 0;
  }

  .mv-colloquium >>> #playbtn{
    width: 13% !important;
    position: absolute;
    top: 50%;
    left: 50% !important;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
  }

  .mv-colloquium >>> .showhow{
    position: absolute;
    left: 185px !important;
    z-index: 9999;
    bottom: 10px;
  }

  .mv-colloquium >>> .mdh1{
    padding: 10px !important;
  }

  .mv-colloquium >>> .display-none{
    display: none;
  }
  
}

/* Desktop View */
@media only screen and (min-width: 992px){
  .mv-colloquium >>> .mdh2{
    padding-right: 0 !important;
  }
  
  .mv-colloquium >>> #manan-img{
    padding: 30px 0 0 30px;
  }
  
  .mv-colloquium >>> #playbtn{
    position: absolute;
    top: 270px;
    left: 320px; 
    width: 15% !important;
  }


  .mv-colloquium >>> .top-left-borders{
    border-left: 4px solid var(--primary-color);
    border-top: 4px solid var(--primary-color);
    width: 150px;
    height: 150px;
    position: absolute;
  }
}

</style>